import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  title: {
    fontWeight: 'bold'
  },
  panel: {
    padding: '0',
    margin: '0 !important',
    boxShadow: 'none',
    borderTop: '1px solid #e2ebf6',
    '&:first-child': {
      borderRadius: '0'
    },
    '&:last-child': {
      borderRadius: '0',
      borderBottom: '1px solid #e2ebf6'
    },
    '&:before': {
      display: 'none'
    }
  },
  panelSummary: {
    minHeight: '42px !important',
    padding: '0'
  },
  panelSummaryContent: {
    margin: '0'
  },
  panelSummaryExpanded: {
    margin: '0 !important'
  },
  expandIcon: {
    padding: '0',
    margin: '0'
  },
  icon: {
    fontSize: '20px',
    color: '#748CA0'
  },
  panelDetails: {
    padding: '8px 0 20px',
    flexDirection: 'column'
  },
  image: {
    width: '300px',
    height: '160px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: '3px',
    backgroundColor: '#E2F5F8',
    marginBottom: '20px'
  }
});

export default useStyles;
